import React, { useEffect, useState } from "react";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

import TextField from "@material-ui/core/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import styles from "./styles";
import withStyles from "@material-ui/core/styles/withStyles";

import FormWarning from "./FormWarning";

const EasyAutocomplete = props => {
  const { propName, classes } = props;
  const [options, setOptions] = useState([]);
  const fieldValue = props.connectForm.getValue(propName) || "";

  useEffect(() => {
    props.connectForm.setPropMounted(propName, true);

    const newOptions = [];
    if (props.connectForm.getDropdownOptions(propName))
      for (let option of props.connectForm.getDropdownOptions(propName)) {
        var value, label;
        if (Array.isArray(option)) {
          value = option[0];
          label = option[1];
        } else {
          value = option;
          label = option;
        }
        newOptions.push({ value, label });
      }
    setOptions(newOptions);

    return () => {
      props.connectForm.setPropMounted(propName, false);
    };
  }, []);

  useEffect(() => {
    if (props.customOptions) setOptions(props.customOptions);
  }, [props.customOptions]);

  const shouldDisplayLabel = () => {
    return props.connectForm.getLabel(propName) === "Type" ||
      props.connectForm.getLabel(propName) ===
        "Where did you hear about MCSnet?" ||
      props.connectForm.getLabel(propName) === "Quarter" ||
      props.connectForm.getLabel(propName) === "Section" ||
      props.connectForm.getLabel(propName) === "Township" ||
      props.connectForm.getLabel(propName) === "Range" ||
      props.connectForm.getLabel(propName) === "Meridian"
      ? true
      : false;
  };

  return (
    <div>
      <FormControl
        fullWidth
        className={classes.selectFormControl}
        error={props.connectForm.getState(propName) === "Error"}
      >
        {shouldDisplayLabel ? null : (
          <InputLabel htmlFor={propName} className={classes.selectLabel}>
            {props.connectForm.getLabel(propName) + " "}
            {props.connectForm.isRequired(propName) ? (
              <span style={{ color: "rgb(10 64 101)" }}>*</span>
            ) : (
              ""
            )}
          </InputLabel>
        )}
        <Autocomplete
          className={classes.autoComplete}
          options={options}
          freeSolo={props.useAsSolo}
          inputValue={String(fieldValue)}
          getOptionLabel={option => String(option.label)}
          onInputChange={(e, value, reason) => {
            if (props.onInputChange) {
              props.onInputChange(e, value, reason);
            }
            if (props.useAsSolo) {
              props.connectForm.change(value, propName);
            }
          }}
          onChange={(event, newValue) => {
            if (newValue) {
              props.connectForm.change(
                props.useLabelAsState ? newValue.label : newValue.value,
                propName
              );
            } else {
              props.connectForm.change("", propName);
            }
            if (props.onChange) {
              props.onChange(event, newValue);
            }
          }}
          renderInput={params => <TextField {...params} variant="outlined" />}
        />
      </FormControl>
      <FormWarning
        isValid={props.propName}
        isError={props.connectForm.getState(propName)}
        errorMessage={props.connectForm.getErrorMessage(propName)}
      />
    </div>
  );
};

export default withStyles(styles)(EasyAutocomplete);

//
//
